import { gql, useQuery } from '@apollo/client';
import { AlertBanner, Link } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';
import {
  EnforcementPolicy,
  InsightsEnforcementWarningQuery,
  InsightsEnforcementWarningQueryVariables,
} from 'src/lib/graphqlTypes/types';
import { DocsRouter } from 'src/lib/routers';

const insightsEnforcementWarningQuery = gql`
  query InsightsEnforcementWarningQuery($graphId: ID!, $graphVariant: String!) {
    graph(id: $graphId) {
      id
      variant(name: $graphVariant) {
        id
        ruleEnforcements {
          id
          policy
          deletedAt
        }
      }
    }
  }
`;

const policyMessages = new Map<EnforcementPolicy, string>([
  [EnforcementPolicy.OPERATION_ID_CARDINALITY, 'operation shape cardinality'],
  [EnforcementPolicy.CLIENT_NAME_CARDINALITY, 'client name cardinality'],
  [EnforcementPolicy.CLIENT_VERSION_CARDINALITY, 'client version cardinality'],
]);

export const InsightsEnforcementWarning = ({
  className,
}: {
  className?: string;
}) => {
  const graphRef = useGraphRef();
  const { data } = useQuery<
    InsightsEnforcementWarningQuery,
    InsightsEnforcementWarningQueryVariables
  >(insightsEnforcementWarningQuery, {
    variables: {
      graphId: graphRef?.graphId ?? '',
      graphVariant: graphRef?.graphVariant ?? '',
    },
    skip: !graphRef,
  });
  const activeEnforcements = data?.graph?.variant?.ruleEnforcements.filter(
    (re) => !re.deletedAt,
  );
  return (activeEnforcements?.length ?? 0) > 0 ? (
    <div className={classnames('grid grid-cols-1 gap-2', className)}>
      {activeEnforcements?.map((re) => (
        <AlertBanner key={re.id} status="warning">
          Limit exceeded for {policyMessages.get(re.policy) ?? 'unknown policy'}
          . Your usage data is currently being affected. Learn more about these
          limits in the{' '}
          <Link to={DocsRouter.path('IngestionLimits')} isExternal>
            Studio documentation.
          </Link>
        </AlertBanner>
      ))}
    </div>
  ) : null;
};
